<div [style.color]="color">
  {{ title }}
</div>
